'use strict';

import angular from 'angular';
import NanoreaderAddController from './nanoreader.controller';

export default angular.module('updateServerApp.firmwares.nanoreader', [])
    .controller('FirmwaresNanoreaderAddController', NanoreaderAddController)
    .name;



// WEBPACK FOOTER //
// ./client/app/firmwares/nanoreader/index.js